const gDate = {};

gDate.toDate = (date) => {
    if (typeof date === 'number' || date instanceof Date) {
        return new Date(date);
    }
    if (!date || !date.match) {
        return new Date();
    }

    const now = new Date();

    const datetimeReg = /((\d{2,4})-(\d{1,2})(-(\d{1,2}))?)?\s{0,1}((\d{1,2}):(\d{1,2})(:(\d{1,2}))?)?/;
    const dataMatch = date.match(datetimeReg);
    const year = dataMatch[2] ? +dataMatch[2] : now.getFullYear();
    const month = dataMatch[3] ? +dataMatch[3] : now.getMonth() + 1;
    const day = dataMatch[5] ? +dataMatch[5] : now.getDate();
    const hour = dataMatch[7] ? +dataMatch[7] : 0;
    const minute = dataMatch[8] ? +dataMatch[8] : 0;
    const second = dataMatch[10] ? +dataMatch[10] : 0;

    let dateObj = now;
    dateObj = new Date(+year, +month - 1, +day, +hour, +minute, +second);
    return dateObj;
};
gDate.transNormal = (baseDate, num, type) => {
    baseDate = gDate.toDate(baseDate);
    const transDate = new Date(+baseDate);
    switch (type) {
        case 'day': transDate.setDate(transDate.getDate() + num); break;
        case 'hour': transDate.setHours(transDate.getHours() + num); break;
        case 'minute': transDate.setMinutes(transDate.getMinutes() + num); break;
        case 'second': transDate.setSeconds(transDate.getSeconds() + num); break;
        default: transDate.setDate(transDate.getDate() + num); break;
    }
    return transDate;
};
gDate.transDay = (baseDate, num) => gDate.transNormal(baseDate, num, 'day');
gDate.datetimeFormat = (timeValue, reg, emptyValue) => {
    const empty = emptyValue === undefined ? 0 : emptyValue;
    if ((!timeValue && timeValue !== 0) || (timeValue === empty)) {
        return '';
    }
    const time = gDate.toDate(timeValue);
    const weekHash = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
    const fullYear = time.getFullYear();
    const subYear = `0${(fullYear % 100)}`.slice(-2);
    const fullMonth = `0${(time.getMonth() + 1)}`.slice(-2);
    const fullDate = `0${time.getDate()}`.slice(-2);
    const fullHour = `0${time.getHours()}`.slice(-2);
    const fullMinute = `0${time.getMinutes()}`.slice(-2);
    const fullSecond = `0${time.getSeconds()}`.slice(-2);
    const fullDay = weekHash[time.getDay()];
    let beforeStr = '';
    let afterStr = reg || 'YYYY-MM-DD';
    if (reg === 'before') {
        const timeDay = (new Date(time)).setHours(0, 0, 0, 0);
        const now = (new Date()).setHours(0, 0, 0, 0);
        const inter = (+now - timeDay) / 1000 / 3600 / 24;
        if (inter === 1) {
            beforeStr = '昨日 ';
        } else if (inter === 0) {
            beforeStr = '今日 ';
        }
        afterStr = `${fullHour}:${fullMinute}:${fullSecond}`;
    } else if (reg === 'time') {
        return `${fullHour}:${fullMinute}:${fullSecond}`;
    } else {
        afterStr = afterStr.replace('YYYY', fullYear);
        afterStr = afterStr.replace('YY', subYear);
        afterStr = afterStr.replace('MM', fullMonth);
        afterStr = afterStr.replace('DD', fullDate);
        afterStr = afterStr.replace('HH', fullHour);
        afterStr = afterStr.replace('mm', fullMinute);
        afterStr = afterStr.replace('ss', fullSecond);
        afterStr = afterStr.replace('dd', fullDay);
    }
    return beforeStr + afterStr;
};

export default gDate;
